@if (form) {
  <mat-card>
    <app-card-header
      [title]="'Poner en Espera'"
      [subtitle]="'Aplazar el tratamiento del evento'"
      icono="pause_circle"
      [botonCerrar]="true"
      (cerrar)="dialogRef.close()"
    ></app-card-header>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <mat-card-content class="card-content-crear">
        <!-- Aplazar por minutos -->
        <section class="inputs-group">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Poner en espera por</mat-label>
            <input
              type="number"
              placeholder="Minutos de espera"
              matInput
              [matAutocomplete]="auto"
              (change)="onMinutosChange(+$any($event.target).value)"
              aria-label="Minutos de espera"
            />
            <span matTextSuffix>minutos</span>
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="onMinutosChange($event.option.value)"
            >
              <mat-option [value]="5">
                <mat-icon>schedule</mat-icon>
                5 minutos
              </mat-option>
              <mat-option [value]="10">
                <mat-icon>schedule</mat-icon>
                10 minutos
              </mat-option>
              <mat-option [value]="15">
                <mat-icon>schedule</mat-icon>
                15 minutos
              </mat-option>
              <mat-option [value]="20">
                <mat-icon>schedule</mat-icon>
                20 minutos
              </mat-option>
              <mat-option [value]="30">
                <mat-icon>schedule</mat-icon>
                30 minutos
              </mat-option>
            </mat-autocomplete>
            <mat-hint>Seleccioná o ingresá la cantidad de minutos</mat-hint>
          </mat-form-field>
        </section>

        <!-- Nota -->
        <section class="inputs-group">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nota</mat-label>
            <textarea
              matInput
              formControlName="nota"
              rows="4"
              placeholder="Motivo de la espera (visible para el cliente)..."
              aria-label="Nota del aplazamiento"
            ></textarea>
            <mat-hint>Esta nota será visible para el cliente</mat-hint>
          </mat-form-field>
        </section>

        <!-- Nota Interna -->
        <section class="inputs-group">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nota Interna</mat-label>
            <textarea
              matInput
              formControlName="notaInterna"
              rows="4"
              placeholder="Nota interna sobre el aplazamiento..."
              aria-label="Nota interna del aplazamiento"
            ></textarea>
            <mat-hint>Esta nota es solo para uso interno</mat-hint>
          </mat-form-field>
        </section>
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
          Cancelar
        </button>
        <button
          irxBoton="principal"
          type="submit"
          [disabled]="!this.form.valid || loading"
        >
          <mat-icon>pause</mat-icon>
          Poner en espera
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
}
